import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import front from '@/../static/js/proto/CtpFront';
import model from '@/../static/js/proto/Model';
/**
 * 交易时，填写价格的键盘
 */
@Component({
  name: 'TradeKeyboard',
})
export default class TradeKeyboard extends Vue {
  @Prop()
  public price;
  @Prop()
  public priceType;
  @Prop()
  public priceHolder;
  @Prop()
  public exclude: Node | Node[] | ((current: Node) => boolean);
  @Prop()
  public title: string;
  @Prop()
  public boardPrice;
  @Prop({ default: {} })
  public tick;
  @Prop()
  public priceTicks;
  @Prop({ default: true })
  public showPriceType: boolean;
  // @Prop()
  // public priceTicks;
  public falge: boolean = true;

  public list = [
    {
      text: '排队价',
      value: model.trader.queue_price_mode,
    },
    {
      text: '对手价',
      value: model.trader.match_price_mode,
    },
    {
      text: '最新价',
      value: model.trader.latest_price_mode,
    },
    {
      text: '市价',
      value: model.trader.market_price_mode,
    },
    {
      text: '超价',
      value: model.trader.extend_price_mode,
    },
  ];

  public handleClose() {
    this.$emit('close');
  }
  public handlePriceType(item) {
    this.$emit('update:priceType', item.value);
    this.$emit('update:priceHolder', item.text);
    this.$store.commit('keyBoard/changePriceFlage', false);
    this.$emit('update:price', '');

    this.$nextTick(() => {
      this.$emit('change');
    });
  }
  public onPriceChange(v) {
    // if (this.falge) {
      this.$emit('update:price', v);
      this.$nextTick(() => {
        this.$emit('change');
      });
      if (!v) {
        this.$store.commit('keyBoard/changePriceFlage', false);
      }
    // }
    // this.falge = v ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/views/TradeDetail/components/Tradekeyboard/TradeKeyboard.ts